import styled from 'styled-components';
import { type ModelConfiguratorDetailsFragment } from '../../../../api/fragments/ModelConfiguratorDetails';
import breakpoints from '../../../../utilities/breakpoints';
import renderMarkdown from '../../../../utilities/renderMarkdown';
import useTranslatedString from '../../../../utilities/useTranslatedString';
import { DefaultContainer, Title, SubTitle } from './ui';

const PageDescriptionContainer = styled.div`
    padding: 2.875rem 0 0;
    color: #000000;

    @media screen and (max-width: ${breakpoints.md}) {
        padding-top: 2rem;
    }
`;

const Description = styled.div`
    margin-top: 0.75rem;
    font-size: 18px;

    img {
        max-width: 100%;
    }
`;

export type PageDescriptionProps = {
    modelConfigurator: ModelConfiguratorDetailsFragment;
};

const PageDescription = ({ modelConfigurator }: PageDescriptionProps) => {
    const translate = useTranslatedString();

    return (
        <DefaultContainer>
            <PageDescriptionContainer>
                <Title>{translate(modelConfigurator.pageTitle)}</Title>
                <SubTitle>{translate(modelConfigurator.pageSubtitle)}</SubTitle>
                <Description>{renderMarkdown(translate(modelConfigurator.pageDescription))}</Description>
            </PageDescriptionContainer>
        </DefaultContainer>
    );
};

export default PageDescription;
